// icons
import { Cog, MessageSquare, PhoneCall } from 'lucide-react';
// utils
import { cn } from '@/utils';

interface ConnectorChannelProps {
    channel: string | null;
    className?: string;
}

const ConnectorChannel = ({ className, channel }: ConnectorChannelProps) => {
    const channelClassName = cn('flex items-center gap-1', className);

    switch (channel) {
        case 'text': {
            return (
                <div className={channelClassName}>
                    <MessageSquare /> Text
                </div>
            );
        }
        case 'voice': {
            return (
                <div className={channelClassName}>
                    <PhoneCall /> Voice
                </div>
            );
        }
        default: {
            return (
                <div className={channelClassName}>
                    <Cog /> Technical
                </div>
            );
        }
    }
};

export default ConnectorChannel;
